import {
  Yes,
  errorNotePrequalificationField,
  prequalificationField,
  prequalificationSection
} from '../../utils/constant';
import { getFieldValue } from '../utils';
import { getLocale } from '../../misc';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const prequalificationSectionHelpers = ({ fieldName, formFields }) => {
  const locale = getLocale();
  const {
    vulcanWebform: { yes }
  } = locale === 'en-US' ? EN : FR;
  if (
    fieldName === prequalificationSection ||
    fieldName === errorNotePrequalificationField
  ) {
    const prequalificationFieldsValue = prequalificationField.map(value => {
      return getFieldValue(value, formFields) === yes;
    });
    if (
      fieldName === errorNotePrequalificationField &&
      !prequalificationFieldsValue.includes(true)
    ) {
      return true;
    }
  }
};

export default prequalificationSectionHelpers;
